import Reducer from './Reducers'
import thunkMiddleware from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'

const ReduxStore = createStore(Reducer, applyMiddleware(thunkMiddleware))
export default ReduxStore
